import React, { useState, useEffect, useRef } from "react";
import "../styles/Chatbot.css";

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { sender: "bot", text: "👋 Hi! Welcome to JobHotspot! How can I assist you today?" }
  ]);
  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSendMessage = () => {
    if (!input.trim()) return;

    const userMessage = { sender: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);
    setInput("");
    setIsTyping(true);

    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: getBotResponse(input) }
      ]);
      setIsTyping(false);
    }, 1200);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSendMessage();
  };

  const getBotResponse = (input) => {
    input = input.toLowerCase();

    // Greetings
    if (input.includes("hello") || input.includes("hi")) 
      return "Hello! 👋 Welcome to JobHotspot! How can I assist you today?";

    // Job-related queries
    if (input.includes("job") || input.includes("apply"))
      return "💼 JobHotspot connects job seekers with top employers. Visit our 'Jobs' section to explore opportunities and apply!";

    // Resume-related queries
    if (input.includes("resume") || input.includes("cv"))
      return "📄 Need a professional resume? Use our **Resume Builder** to create a standout CV in minutes!";

    // Interview preparation
    if (input.includes("interview"))
      return "🎤 Ace your interviews with our expert **mock interview sessions, tips, and company insights**!";

    // Skills development
    if (input.includes("skills"))
      return "💡 In-demand skills: **Web Development, Data Science, AI, Cloud Computing**. JobHotspot offers free resources to upskill!";

    // Contact information
    if (input.includes("contact") || input.includes("support"))
      return "📞 Contact us at **support@jobhotspot.com** or call **+91 9876543210**.";

    // Employers/Recruiters
    if (input.includes("company") || input.includes("employer") || input.includes("recruiter"))
      return "🏢 Employers can post job listings on JobHotspot and connect with skilled candidates. Visit **Post a Job** section!";

    // About JobHotspot
    if (input.includes("jobhotspot") || input.includes("about this website"))
      return "🌟 **JobHotspot** is a platform for job seekers and employers. We offer **job listings, resume tools, interview prep, and career guidance** to help users land their dream job! 🚀";

    // Goodbye messages
    if (input.includes("goodbye") || input.includes("bye"))
      return "👋 Goodbye! Best of luck with your job search!";

    return "🤔 I'm not sure about that. Try asking about **jobs, resume tips, interviews, or JobHotspot features**!";
  };

  return (
    <div className="chatbot">
      {/* Chatbot Toggle Button */}
      <button className={`chatbot-toggle ${isOpen ? "open" : ""}`} onClick={() => setIsOpen(!isOpen)}>
        💬
      </button>

      {/* Chat Window */}
      {isOpen && (
        <div className="chatbot-container">
          <div className="chat-header">
            <h3>JobHotspot Assistant 🤖</h3>
            <button className="close-btn" onClick={() => setIsOpen(false)}>✖</button>
          </div>

          <div className="chat-window">
            {messages.map((msg, idx) => (
              <div key={idx} className={`message ${msg.sender}`}>
                {msg.text}
              </div>
            ))}
            {isTyping && <div className="typing">🤖 Bot is typing...</div>}
            <div ref={chatEndRef}></div>
          </div>

          <div className="input-area">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Ask me anything..."
            />
            <button onClick={handleSendMessage}>➤</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chatbot;
